import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from './confirm-modal.component';
import { ConfirmModalDirective } from './confirm-modal.directive';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
    declarations: [ConfirmModalComponent, ConfirmModalDirective],
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        FGBSharedModule
    ],
    exports: [ConfirmModalComponent, ConfirmModalDirective]
})
export class ConfirmModalModule {}
